import { render } from "./PermissionsErrorMsg.vue?vue&type=template&id=27c95746&scoped=true"
import script from "./PermissionsErrorMsg.vue?vue&type=script&lang=js"
export * from "./PermissionsErrorMsg.vue?vue&type=script&lang=js"

import "./PermissionsErrorMsg.vue?vue&type=style&index=0&id=27c95746&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c95746"]])

export default __exports__